var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70859 6.29219C8.09922 6.68281 8.09922 7.31719 7.70859 7.70781L1.70859 13.7078C1.31797 14.0984 0.683594 14.0984 0.292969 13.7078C-0.0976562 13.3172 -0.0976562 12.6828 0.292969 12.2922L5.58672 6.99844L0.296094 1.70469C-0.0945313 1.31406 -0.0945313 0.679688 0.296094 0.289062C0.686719 -0.101562 1.32109 -0.101562 1.71172 0.289062L7.71172 6.28906L7.70859 6.29219Z",
    fill: "#091644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryArrow);
export default __webpack_public_path__ + "static/media/Primary_Arrow.7e842e26ab27a3392de89ddb12463c88.svg";
export { ForwardRef as ReactComponent };